export default "__VITE_ASSET__CDW$9CBW__"